import { render } from "./AgentActionFolderLocation.vue?vue&type=template&id=15997d94&scoped=true&ts=true"
import script from "./AgentActionFolderLocation.vue?vue&type=script&lang=ts"
export * from "./AgentActionFolderLocation.vue?vue&type=script&lang=ts"

import "./AgentActionFolderLocation.vue?vue&type=style&index=0&id=15997d94&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15997d94"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QIcon,QField});
